import { gql } from "@apollo/client";

export const UPDATE_PART_ORDER = gql`
  mutation UpdatePartOrder($partOrder: CUDPartOrderInput!) {
    updatePartOrder(partOrder: $partOrder) {
      _id
      id
      requested_date
      ticket_number
      ticket_id
      link
      vendor_part_number
      description
      warranty_type
      status
      ordered_date
      ordered
      vendor
      po_number
      price
      shipping_price
      total_price
      payment_method
      eta
      tracking_number
      received
      received_date
      notes
      created_at
      updated_at
      quantity
      customer {
        _id
        id
        fullname
        business_name
      }
    }
  }
`;

export const DELETE_MANY_PART_ORDERS = gql`
  mutation DeleteManyPartOrders($partOrders: [CUDPartOrderInput!]!) {
    deleteManyPartOrders(partOrders: $partOrders) {
      _id
      id
      requested_date
      ticket_number
      ticket_id
      link
      vendor_part_number
      description
      warranty_type
      status
      ordered_date
      ordered
      vendor
      po_number
      price
      shipping_price
      total_price
      payment_method
      eta
      tracking_number
      received
      received_date
      notes
      created_at
      updated_at
      quantity
      customer {
        _id
        id
        fullname
        business_name
      }
    }
  }
`;

export const CREATE_PART_ORDER = gql`
  mutation CreatePartOrder($partOrder: CUDPartOrderInput!) {
    createPartOrder(partOrder: $partOrder) {
      _id
      id
      requested_date
      ticket_number
      ticket_id
      link
      vendor_part_number
      description
      warranty_type
      status
      ordered_date
      ordered
      vendor
      po_number
      price
      shipping_price
      total_price
      payment_method
      eta
      tracking_number
      received
      received_date
      notes
      created_at
      updated_at
      quantity
      customer {
        _id
        id
        fullname
        business_name
      }
    }
  }
`;
